import { v4 as uuid } from 'uuid';

export class Note {
  id = uuid();
  title = '';
  body = '';
  deleted = false;
  order = 0;
}
